import { AppActionsButton } from '../../actions/AppsActionButton';
export const actionCellRender = (e) => {
    return (
        <AppActionsButton
            application={e.data}
            parentElementId='bridgeAppsId'
        />
    );
};
